import React from "react";

export const MondayImportSkeleton = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="352" height="497" fill="none" viewBox="0 0 352 497">
      <rect width="317" height="33" x="17" y="156.945" fill="#EBEDF3" rx="6"></rect>
      <rect width="80" height="16" x="17" y="135" fill="#EBEDF3" rx="6"></rect>
      <rect width="177" height="16" x="17" fill="#EBEDF3" rx="6"></rect>
      <rect width="317" height="33" x="17" y="195" fill="#EBEDF3" rx="6"></rect>
      <rect width="317" height="33" x="17" y="233.055" fill="#EBEDF3" rx="6"></rect>
      <rect width="317" height="33" x="17" y="271.109" fill="#EBEDF3" rx="6"></rect>
      <path stroke="#E5E8EA" d="M0 117.5h352"></path>
      <path
        fill="#EBEDF3"
        d="M17 41a6 6 0 0 1 6-6h144a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H23a6 6 0 0 1-6-6zM179 41a6 6 0 0 1 6-6h144a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H185a6 6 0 0 1-6-6zM303 81a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6zM17 81a6 6 0 0 1 6-6h266a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6H23a6 6 0 0 1-6-6z"
      ></path>
      <rect width="317" height="33" x="18" y="348.945" fill="#EBEDF3" rx="6"></rect>
      <rect width="80" height="16" x="18" y="327" fill="#EBEDF3" rx="6"></rect>
      <rect width="317" height="33" x="18" y="387" fill="#EBEDF3" rx="6"></rect>
      <rect width="317" height="33" x="18" y="425.055" fill="#EBEDF3" rx="6"></rect>
      <rect width="317" height="33" x="18" y="463.109" fill="#EBEDF3" rx="6"></rect>
    </svg>
  );
};

export const MondayImportItemsSkeleton = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" fill="none" viewBox="8 168 350 369">
      <defs>
        <linearGradient id="shimmer-gradient-2" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#EBEDF3" stopOpacity="1" />
          <stop offset="50%" stopColor="#f5f6f8" stopOpacity="1" />
          <stop offset="100%" stopColor="#EBEDF3" stopOpacity="1" />
          <animate attributeName="x1" from="-100%" to="100%" dur="2.2s" repeatCount="indefinite" />
          <animate attributeName="x2" from="0%" to="200%" dur="2.2s" repeatCount="indefinite" />
        </linearGradient>
        <filter
          id="filter0_d_1301_4734"
          width="368"
          height="539"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="4"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1301_4734"></feBlend>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1301_4734" result="shape"></feBlend>
        </filter>
      </defs>
      <rect width="80" height="16" x="25" y="165" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="25" y="186.945" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="25" y="225" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="25" y="263.055" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="25" y="301.109" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="80" height="16" x="26" y="357" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="26" y="378.945" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="26" y="417" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="26" y="455.055" fill="url(#shimmer-gradient-2)" rx="6"></rect>
      <rect width="317" height="33" x="26" y="493.109" fill="url(#shimmer-gradient-2)" rx="6"></rect>
    </svg>
  );
};
